import TournamentPuzzleInfo from './TournamentPuzzleInfo';

export default TournamentPuzzleInfo;
